import React from "react";
import { Link, useLocation } from "react-router-dom";
import { EpaperIcon } from "./Icons";
import Marquee from "./Marquee";

const Header = ({ lang, setLang, textData, ticker }) => {
  const location = useLocation();
  const [navOpen, setNavOpen] = React.useState(false);
  React.useEffect(() => {
    const handler = () => setNavOpen(false);
    window.addEventListener("closeNav", handler);
    return () => window.removeEventListener("closeNav", handler);
  }, []);
  const today = new Date();
  const dateString = today.toLocaleDateString(
    lang === "gu" ? "gu-IN" : "en-US",
    { weekday: "long", day: "numeric", month: "long", year: "numeric" }
  );
  const timeString = today.toLocaleTimeString(
    lang === "gu" ? "gu-IN" : "en-US",
    { hour: "2-digit", minute: "2-digit", hour12: true }
  );

  const getLinkForItem = (item) => {
    const lowerItem = item.toLowerCase();
    if (lowerItem === "home") return "/";
    if (lowerItem === "videos") return "/videos";
    if (lowerItem === "shorts") return "/shorts";
    if (lowerItem === "ahmedabad") return "/category/localnews";
    if (lowerItem === "sports") return "/category/sportsnews";
    if (lowerItem === "lifestyle") return "/category/other";
    return `/category/${lowerItem}`;
  };

  return (
    <header className="bg-white shadow-md">
      <div className="bg-gray-800 text-white text-xs sm:text-sm py-1">
        <div className="container mx-auto px-2 sm:px-4 flex flex-col sm:flex-row justify-between items-center gap-2">
          <span>{dateString}</span>
          <span>Ahmedabad: ({timeString})</span>
        </div>
      </div>
      <div className="container mx-auto px-2 sm:px-4 py-2">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 w-full">
          <div className="flex-shrink-0 w-48 h-20">
            <Link
              to="/"
              onClick={() => {
                setNavOpen(false);
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              <img
                src="/AP_Still.png"
                alt="Logo"
                className="w-full h-full object-cover rounded-lg cursor-pointer"
              />
            </Link>
          </div>
          <div className="bg-[#ffbb00] border border-yellow-300 rounded-full px-4 py-2 flex-grow overflow-hidden flex items-center space-x-2 text-sm text-gray-800 w-full">
            <span className="bg-red-700 w-2 h-2 rounded-full animate-pulse flex-shrink-0"></span>
            <div className="w-full">
              <Marquee text={ticker.join("   •   ")} pixelsPerSecond={90} />
            </div>
          </div>
          <div className="hidden md:flex items-center space-x-2">
            <Link to="/epaper">
              <button className="bg-[#ffbb00] text-gray-900 font-semibold py-2 rounded-lg flex items-center justify-center hover:bg-yellow-200 transition duration-300 w-40">
                <EpaperIcon />
                {textData.buttons.epaper}
              </button>
            </Link>
          </div>
        </div>
      </div>
      <nav className="bg-red-700 text-white relative">
        <div className="container mx-auto px-4 flex items-center justify-between">
          <div className="md:hidden">
            <button
              onClick={() => setNavOpen(!navOpen)}
              className="p-2 focus:outline-none"
            >
              <svg
                className="w-7 h-7"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
          </div>

          <ul className="hidden md:flex flex-wrap justify-center md:justify-start space-x-2 font-semibold">
            {textData.nav.map((item) => {
              const linkPath = getLinkForItem(item);
              const isActive =
                item.toLowerCase() !== "home" && location.pathname === linkPath;
              return (
                <li key={item}>
                  <Link
                    to={linkPath}
                    className={`block py-3 px-3 rounded-md transition-colors duration-200 ${
                      isActive
                        ? "bg-red-900"
                        : "hover:bg-red-800"
                    }`}
                  >
                    {item}
                  </Link>
                </li>
              );
            })}
          </ul>

          <div className="md:hidden">
            <Link to="/epaper">
              <button className="bg-[#ffbb00] text-gray-900 font-semibold py-1 px-3 rounded-lg flex items-center justify-center hover:bg-yellow-200 transition duration-300 text-sm">
                <EpaperIcon />
                {textData.buttons.epaper}
              </button>
            </Link>
          </div>
        </div>
        {navOpen && (
          <div className="md:hidden absolute left-0 top-full bg-white text-gray-900 rounded-b-lg shadow-lg z-50 w-full">
            <ul>
              {textData.nav.map((item) => {
                const linkPath = getLinkForItem(item);
                const isActive = location.pathname === linkPath;
                return (
                  <li
                    key={item}
                    className={`border-b last:border-b-0 ${
                      isActive ? "bg-red-50" : ""
                    }`}
                  >
                    <Link
                      to={linkPath}
                      className={`block w-full py-3 px-4 transition-colors duration-200 ${
                        isActive
                          ? "text-red-700 font-semibold"
                          : "hover:bg-gray-100"
                      }`}
                      onClick={() => setNavOpen(false)}
                    >
                      {item}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
